export const ASSET_SOURCES = ["kyw", "vp"] as const;

export const ASSET_STATES = [
  "awaiting_review",
  "awaiting_valuation",
  "failed_auto_unqualified",
  "failed_login_2fa_block",
  "failed_login_invalid_credentials",
  "failed_need_credentials_update",
  "failed_unqualified",
  "qualified",
  "undefined",
] as const;

export const ASSET_STATE_TO_USER_INFO = {
  awaiting_review: {
    headerMessage: "Awaiting Review",
    message: "",
    details: "",
  },
  awaiting_valuation: {
    headerMessage: "Awaiting Valuation",
    message: "",
    details: "",
  },
  qualified: {
    headerMessage: "Qualified",
    message: "",
    details: "",
  },
  failed_auto_unqualified: {
    headerMessage: "Unqualified",
    message: "Account Not Qualified",
    details: "longer version of the info",
  },
  failed_login_2fa_block: {
    headerMessage: "Invalid 2FA",
    message: "Error Processing Valuation - 2FA Required",
    details:
      "Royalty Exchange needs your permission to access your account. A member of our team will reach out shortly.",
  },
  failed_login_invalid_credentials: {
    headerMessage: "Invalid Credentials",
    message: "Error Processing Valuation - Credential Error",
    details: "Please update your credentials to re-establish connection.",
  },
  failed_need_credentials_update: {
    headerMessage: "Update Submission",
    message: "Update Credential Submission",
    details: "Click here to update your credentials and earnings.",
  },
  failed_unqualified: {
    headerMessage: "Unqualified",
    message: "Account Not Qualified",
    details: "Please come back once your yearly earnings have updated.",
  },
  undefined: {
    headerMessage: "Unqualified",
    message: "Connection Lost Please Contact Us!",
    details: "Account Not Qualified - Please Contact Us.",
  },
} as const;
